import { Injectable } from '@angular/core';
import { Http, Response, URLSearchParams, BaseRequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';

import { MarketdateMeterreading } from './marketdate-meterreading.model';
import { DateUtils } from 'ng-jhipster';
@Injectable()
export class MarketdateMeterreadingService {

    private resourceUrl = 'api/marketdate-meterreadings';
    private resourceSearchUrl = 'api/_search/marketdate-meterreadings';

    constructor(private http: Http, private dateUtils: DateUtils) { }

    create(marketdateMeterreading: MarketdateMeterreading): Observable<MarketdateMeterreading> {
        const copy: MarketdateMeterreading = Object.assign({}, marketdateMeterreading);
        copy.timestamp = this.dateUtils.toDate(marketdateMeterreading.timestamp);
        copy.updated = this.dateUtils.toDate(marketdateMeterreading.updated);
        copy.created = this.dateUtils.toDate(marketdateMeterreading.created);
        return this.http.post(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    update(marketdateMeterreading: MarketdateMeterreading): Observable<MarketdateMeterreading> {
        const copy: MarketdateMeterreading = Object.assign({}, marketdateMeterreading);

        copy.timestamp = this.dateUtils.toDate(marketdateMeterreading.timestamp);

        copy.updated = this.dateUtils.toDate(marketdateMeterreading.updated);

        copy.created = this.dateUtils.toDate(marketdateMeterreading.created);
        return this.http.put(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    find(id: number): Observable<MarketdateMeterreading> {
        return this.http.get(`${this.resourceUrl}/${id}`).map((res: Response) => {
            const jsonResponse = res.json();
            jsonResponse.timestamp = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.timestamp);
            jsonResponse.updated = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.updated);
            jsonResponse.created = this.dateUtils
                .convertDateTimeFromServer(jsonResponse.created);
            return jsonResponse;
        });
    }

    query(req?: any): Observable<Response> {
        const options = this.createRequestOption(req);
        return this.http.get(this.resourceUrl, options)
            .map((res: any) => this.convertResponse(res))
        ;
    }

    delete(id: number): Observable<Response> {
        return this.http.delete(`${this.resourceUrl}/${id}`);
    }

    search(req?: any): Observable<Response> {
        const options = this.createRequestOption(req);
        return this.http.get(this.resourceSearchUrl, options)
            .map((res: any) => this.convertResponse(res))
        ;
    }


    private convertResponse(res: any): any {
        const jsonResponse = res.json();
        for (let i = 0; i < jsonResponse.length; i++) {
            jsonResponse[i].timestamp = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].timestamp);
            jsonResponse[i].updated = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].updated);
            jsonResponse[i].created = this.dateUtils
                .convertDateTimeFromServer(jsonResponse[i].created);
        }
        res._body = jsonResponse;
        return res;
    }

    private createRequestOption(req?: any): BaseRequestOptions {
        const options: BaseRequestOptions = new BaseRequestOptions();
        if (req) {
            const params: URLSearchParams = new URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);

            options.search = params;
        }
        return options;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-meterreading/marketdate-meterreading.service.ts